import { useMutation } from '@apollo/client'
import BaseDialog from 'components/dialog'
import { CREATE_NEW_AGENCY_GROUP } from 'queries/admin/agencyGroup'
import React, { useState } from 'react'
import IconTimes from 'assets/images/icon-times.svg'
import InputBase from 'components/partials/inputBase'
import ButtonBase from 'components/partials/button'
import { notify } from 'components/toastify'
import { STATUS } from 'constants/messages'
import { useSession } from 'helpers/checkSession'

interface Props {
  isOpenDialog: boolean
  handleCloseDialog: () => void
}

const styleDialogDefault: ReactModal.Styles = {
  content: {
    width: '100%',
    maxWidth: '500px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    boxShadow: '8px 11px 21px 0px rgba(148,144,144,0.75)',
    background: '#fdfdfd',
    maxHeight: '700px',
    overflow: 'auto',
  },
}

const AddNewAgencyGroupDialog: React.FC<Props> = ({ handleCloseDialog, isOpenDialog }) => {
  const { handleErrorSession } = useSession()
  const [agencyGroupName, setAgencyGroupName] = useState<string>('')
  const [createNewAgencyGroupMutation] = useMutation(CREATE_NEW_AGENCY_GROUP, {
    variables: { data: { agencyGroupName: agencyGroupName } },
    onCompleted: () => {
      notify('Create new Agency Group successfully!', STATUS.SUCCESS)
    },
    onError: (error) => {
      if (error.message) {
        handleErrorSession(error, error.message)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    },
  })

  const onSaveBtn = () => {
    createNewAgencyGroupMutation()
    handleCloseDialog()
  }

  return (
    <BaseDialog modalIsOpen={isOpenDialog} customStyles={styleDialogDefault}>
      <div className="flex flex-col max-h-[600px] overflow-y-scroll overflow-x-hidden px-[5px]">
        <div className="flex justify-between">
          <div />
          <img src={IconTimes} alt="" className="cursor-pointer " onClick={handleCloseDialog} />
        </div>
        <div className="flex justify-center pb-5">
          <p className="text-headline5A text-neutral-1">Create New Agency Group</p>
        </div>

        <div>
          <InputBase
            className="w-full"
            handleChange={(value) => {
              setAgencyGroupName(value)
            }}
            placeholder="Enter Agency Group Name"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-between">
          <ButtonBase
            onClick={onSaveBtn}
            className="w-[150px] my-4 justify-around"
            // disabled={error.isError}
            bgDisabled="bg-primary-shade3"
          >
            Save
          </ButtonBase>
          <ButtonBase
            type="submit"
            className="w-[150px] my-4 justify-around border-2 border-primary-1 text-primary-1 bg-white-50 hover:bg-primary-shade4"
            onClick={handleCloseDialog}
            bgDisabled="bg-primary-shade3"
          >
            Close
          </ButtonBase>
        </div>
      </div>
    </BaseDialog>
  )
}

export default AddNewAgencyGroupDialog
